import { Domain } from '@3nickels/data-modules';
import { Grid } from '@mui/system';
import PlanCard, { PlanCardProps } from '../PlanCard';

interface FreemiumPlanCardsProps extends Omit<PlanCardProps, 'subscription'> {
  freemiumPricebook: Domain.PricebookBundle;
  adviceAddOnPricebook: Domain.PricebookBundle;
  baseSubscription: Domain.SubscriptionInfo | undefined;
  addOnSubscription: Domain.SubscriptionInfo | undefined;
  mobile: boolean;
  openUpsell: () => void;
}

const FreemiumPlanCards: React.FC<FreemiumPlanCardsProps> = ({
  pageContext,
  plan,
  freemiumPricebook,
  adviceAddOnPricebook,
  pricebookMetadata,
  baseSubscription,
  addOnSubscription,
  threeNickelsProducts,
  freeTrialStatus,
  inAdviceFreeTrial,
  userNeverSubscribedToExclusivePricebook,
  footnoteIndex,
  mobile,
  openUpsell,
}) => (
  <Grid display='flex' flexDirection={mobile ? 'column' : 'row'} gap={'20px'}>
    <PlanCard
      pageContext={pageContext}
      plan={freemiumPricebook}
      currentPlan={plan.pricebook.id === freemiumPricebook.pricebook.id ? plan : undefined}
      pricebookMetadata={pricebookMetadata}
      subscription={baseSubscription}
      threeNickelsProducts={threeNickelsProducts}
      freeTrialStatus={freeTrialStatus}
      inAdviceFreeTrial={inAdviceFreeTrial}
      userNeverSubscribedToExclusivePricebook={userNeverSubscribedToExclusivePricebook}
      footnoteIndex={footnoteIndex}
      userIsUnderFreemiumModel
      isFreemium
      hideButton
      hideDetails
      hidePrice
    />
    <PlanCard
      pageContext={pageContext}
      plan={adviceAddOnPricebook}
      pricebookMetadata={pricebookMetadata}
      subscription={addOnSubscription}
      threeNickelsProducts={threeNickelsProducts}
      freeTrialStatus={freeTrialStatus}
      inAdviceFreeTrial={inAdviceFreeTrial}
      userNeverSubscribedToExclusivePricebook={userNeverSubscribedToExclusivePricebook}
      footnoteIndex={footnoteIndex}
      userIsUnderFreemiumModel
      isPremium
      onLearnMore={openUpsell}
      hideDetails
    />
  </Grid>
);

export default FreemiumPlanCards;
